export default "__VITE_ASSET__Cj6_w0_L__"